import { useState } from "react";

import { faCheck, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useTimeout } from "usehooks-ts";

import { Button } from "src/base-components/Button";

type ChatToolApprovalProps = {
  description: React.ReactNode;
  onApprove: VoidFunction;
  onDeny: VoidFunction;
  approveLabel?: string;
  denyLabel?: string;
  disabled?: boolean;
  delay?: number;
  dataLoc?: string;
};

export const ChatToolApproval: React.FC<ChatToolApprovalProps> = ({
  description,
  onApprove,
  onDeny,
  approveLabel = "Yes, allow",
  denyLabel = "Don't allow",
  disabled = false,
  delay = 0,
  dataLoc,
}) => {
  const [render, setRender] = useState(delay === 0);

  useTimeout(() => setRender(true), delay > 0 ? 1000 * delay : null);

  if (!render) {
    return null;
  }

  return (
    <div data-loc={dataLoc}>
      <p className="pb-2 font-inter-normal-12px text-gray-800">{description}</p>

      <div className="flex flex-col gap-y-3">
        <div className="flex gap-x-2">
          <Button
            disabled={disabled}
            iconLeft={faCheck}
            size="sm"
            variant="secondary"
            onClick={onApprove}
          >
            {approveLabel}
          </Button>
          <Button
            disabled={disabled}
            iconLeft={faTimes}
            size="sm"
            variant="secondary"
            onClick={onDeny}
          >
            {denyLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};
